(function () {
  if (window.__wrBookingTimesInit) return;
  window.__wrBookingTimesInit = true;

  var TZ = 'America/Los_Angeles';
  var MSG_SAME = 'Option 2 must be a different date and time than Option 1.';
  var MSG_PAST = 'Please choose today or a future date (Pacific Time).';
  var MSG_REQ = 'Please select a date.';
  var DOW = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var openPop = null;

  function todayPT() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function isoFromYMD(y, m0, d) {
    return y + '-' + pad(m0 + 1) + '-' + pad(d);
  }

  /** ISO -> "Fri, Oct 17, 2026" (display) */
  function formatDisplay(iso) {
    if (!iso) return '';
    var p = iso.split('-');
    if (p.length !== 3) return iso;
    var dt = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12, 0, 0));
    try {
      var wd = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short' }).format(dt);
      var mo = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short' }).format(dt);
      var day = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', day: 'numeric' }).format(dt);
      var yr = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', year: 'numeric' }).format(dt);
      return wd + ', ' + mo + ' ' + day + ', ' + yr;
    } catch (e) {
      return iso;
    }
  }

  /** ISO -> "Fri Oct 17, 2026" (combined email field) */
  function formatNiceDate(iso) {
    return formatDisplay(iso).replace(/^([A-Za-z]{3}),\s*/, '$1 ');
  }

  function combine(iso, timeVal) {
    if (!iso || !timeVal) return '';
    return formatNiceDate(iso) + ' at ' + timeVal;
  }

  function parseIso(iso) {
    if (!iso) return null;
    var p = iso.split('-');
    if (p.length !== 3) return null;
    return { y: +p[0], m0: +p[1] - 1, d: +p[2] };
  }

  function monthLabel(y, m0) {
    var dt = new Date(Date.UTC(y, m0, 1, 12, 0, 0));
    try {
      return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'long', year: 'numeric' }).format(dt);
    } catch (e) {
      return (m0 + 1) + '/' + y;
    }
  }

  function closeOpen() {
    if (!openPop) return;
    var pop = openPop.pop;
    var input = openPop.input;
    if (pop && pop.parentNode) pop.parentNode.removeChild(pop);
    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.classList.remove('wr-cal__input--open');
    }
    openPop = null;
    document.removeEventListener('mousedown', onDocDown, true);
    document.removeEventListener('keydown', onDocKey, true);
  }

  function onDocDown(e) {
    if (!openPop) return;
    if (openPop.wrap.contains(e.target) || (openPop.pop && openPop.pop.contains(e.target))) return;
    closeOpen();
  }

  function onDocKey(e) {
    if (e.key === 'Escape') {
      var inp = openPop && openPop.input;
      closeOpen();
      if (inp) inp.focus();
    }
  }

  function buildPopover(wrap, input, isoHidden, minIso, onPick) {
    closeOpen();
    var selected = isoHidden.value || '';
    var view = parseIso(selected) || parseIso(minIso) || parseIso(todayPT());
    var vy = view.y, vm = view.m0;

    var pop = document.createElement('div');
    pop.className = 'wr-cal__popover';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', 'Choose a date');
    pop.tabIndex = -1;

    function render() {
      var min = minIso;
      var html = '';
      html += '<div class="wr-cal__head">';
      html += '<button type="button" class="wr-cal__nav" data-wr-cal-prev aria-label="Previous month">&#8249;</button>';
      html += '<div class="wr-cal__month" aria-live="polite">' + monthLabel(vy, vm) + '</div>';
      html += '<button type="button" class="wr-cal__nav" data-wr-cal-next aria-label="Next month">&#8250;</button>';
      html += '</div>';
      html += '<div class="wr-cal__dow">';
      for (var i = 0; i < 7; i++) html += '<span>' + DOW[i] + '</span>';
      html += '</div><div class="wr-cal__grid">';

      var first = new Date(Date.UTC(vy, vm, 1));
      var startDow = first.getUTCDay();
      var daysInMonth = new Date(Date.UTC(vy, vm + 1, 0)).getUTCDate();
      var today = todayPT();

      for (var cell = 0; cell < 42; cell++) {
        var dayNum = cell - startDow + 1;
        if (dayNum < 1 || dayNum > daysInMonth) {
          html += '<button type="button" class="wr-cal__day wr-cal__day--empty" disabled tabindex="-1"></button>';
          continue;
        }
        var iso = isoFromYMD(vy, vm, dayNum);
        var disabled = iso < min;
        var cls = 'wr-cal__day';
        if (iso === today) cls += ' wr-cal__day--today';
        if (iso === selected) cls += ' wr-cal__day--selected';
        if (disabled) cls += ' wr-cal__day--disabled';
        html += '<button type="button" class="' + cls + '" data-iso="' + iso + '"' +
          (disabled ? ' disabled' : '') +
          ' aria-label="' + formatDisplay(iso) + '"' +
          (iso === selected ? ' aria-current="date"' : '') +
          '>' + dayNum + '</button>';
      }
      html += '</div>';
      pop.innerHTML = html;

      pop.querySelector('[data-wr-cal-prev]').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        vm -= 1;
        if (vm < 0) { vm = 11; vy -= 1; }
        render();
      });
      pop.querySelector('[data-wr-cal-next]').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        vm += 1;
        if (vm > 11) { vm = 0; vy += 1; }
        render();
      });
      pop.querySelectorAll('.wr-cal__day[data-iso]:not([disabled])').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          onPick(btn.getAttribute('data-iso'));
          closeOpen();
        });
      });
    }

    render();
    wrap.appendChild(pop);
    input.setAttribute('aria-expanded', 'true');
    input.classList.add('wr-cal__input--open');
    openPop = { pop: pop, input: input, wrap: wrap };
    document.addEventListener('mousedown', onDocDown, true);
    document.addEventListener('keydown', onDocKey, true);

    // Focus first selectable / selected
    setTimeout(function () {
      var sel = pop.querySelector('.wr-cal__day--selected') || pop.querySelector('.wr-cal__day--today:not([disabled])') || pop.querySelector('.wr-cal__day[data-iso]:not([disabled])');
      if (sel) sel.focus();
    }, 0);
  }

  function wireCal(wrap, syncFn) {
    var input = wrap.querySelector('.wr-cal__input, [data-wr-pref-date]');
    var isoHidden = wrap.querySelector('[data-wr-pref-iso]');
    if (!input || !isoHidden) return;
    if (wrap.getAttribute('data-wr-cal-wired') === '1') return;
    wrap.setAttribute('data-wr-cal-wired', '1');

    // JS mode: text field is display-only; strip name so no-JS names don't double-submit
    input.setAttribute('readonly', 'readonly');
    input.removeAttribute('name');
    // Keep required validation on the visible field
    input.setAttribute('required', 'required');

    function open() {
      var min = todayPT();
      buildPopover(wrap, input, isoHidden, min, function (iso) {
        isoHidden.value = iso;
        input.value = formatDisplay(iso);
        input.setCustomValidity('');
        if (syncFn) syncFn();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // Click / focus / Enter / Space anywhere on the field opens the calendar (Chrome Mac fix)
    function wantOpen(e) {
      if (e.type === 'keydown') {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'ArrowDown') return;
        e.preventDefault();
      }
      // Prevent re-open churn if already open for this wrap
      if (openPop && openPop.wrap === wrap) return;
      open();
    }

    input.addEventListener('click', wantOpen);
    input.addEventListener('mousedown', function (e) {
      // Click anywhere in the field (Chrome/Mac): open on mousedown, not only an icon
      e.preventDefault();
      input.focus();
      wantOpen(e);
    });
    input.addEventListener('keydown', wantOpen);

    // Also open when clicking the label/wrapper around the input
    wrap.addEventListener('click', function (e) {
      if (e.target === input) return; // already handled
      if (openPop && openPop.pop && openPop.pop.contains(e.target)) return;
      wantOpen(e);
    });
  }

  function wire(root) {
    if (!root || root.getAttribute('data-wr-booking-wired') === '1') return;
    root.setAttribute('data-wr-booking-wired', '1');

    var form = root.closest('form');
    var min = todayPT();
    var d1 = root.querySelector('[data-wr-pref-date="1"]');
    var d2 = root.querySelector('[data-wr-pref-date="2"]');
    var iso1 = root.querySelector('[data-wr-pref-iso="1"]');
    var iso2 = root.querySelector('[data-wr-pref-iso="2"]');
    var t1 = root.querySelector('[data-wr-pref-time="1"]');
    var t2 = root.querySelector('[data-wr-pref-time="2"]');
    var h1 = root.querySelector('[data-wr-pref-combined="1"]');
    var h2 = root.querySelector('[data-wr-pref-combined="2"]');

    [t1, t2].forEach(function (el) {
      if (!el) return;
      el.removeAttribute('name');
    });

    function isoVal(n) {
      var el = n === 1 ? iso1 : iso2;
      return el ? el.value : '';
    }

    function sync() {
      var i1 = isoVal(1), i2 = isoVal(2);
      if (h1) h1.value = combine(i1, t1 && t1.value);
      if (h2) h2.value = combine(i2, t2 && t2.value);

      if (d1) {
        if (!i1) d1.setCustomValidity(MSG_REQ);
        else if (i1 < min) d1.setCustomValidity(MSG_PAST);
        else d1.setCustomValidity('');
      }
      if (d2) {
        if (!i2) d2.setCustomValidity(MSG_REQ);
        else if (i2 < min) d2.setCustomValidity(MSG_PAST);
        else d2.setCustomValidity('');
      }

      var same =
        i1 && i2 && t1 && t2 && t1.value && t2.value &&
        i1 === i2 && t1.value === t2.value;
      if (t2) t2.setCustomValidity(same ? MSG_SAME : '');
    }

    root.querySelectorAll('[data-wr-cal]').forEach(function (wrap) {
      wireCal(wrap, sync);
    });

    [t1, t2].forEach(function (el) {
      if (!el) return;
      el.addEventListener('change', sync);
      el.addEventListener('input', sync);
    });

    if (form) {
      form.addEventListener('submit', function () { sync(); });
    }

    sync();
  }

  function scan() {
    document.querySelectorAll('[data-wr-booking-times]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-wr-tech-open]')) setTimeout(scan, 80);
  });
})();
